/** @jsxRuntime automatic */
/** @jsxImportSource react */
import { createRoot } from 'react-dom/client'
import { Poll } from './components/Poll.tsx'

const el = document.getElementById('poll-root')
if (el) createRoot(el).render(<Poll />)
